import api from '../../apiConfig/apiConfig'
import {Get} from '../base/baseAjax'
export default {
  ossInit: function() {
    return Get({
        url: api.case.getTokenApi
    })
  }
}
